export const environment = {
  production: false,
  baseUrl: {
    insite: 'https://reporting-dev.app.insite.caci.co.uk/',
    pinroutes: 'https://reporting-dev.pinroutes.com/'
  }
};
